import { all } from "redux-saga/effects";
import { watchHttpAction } from "./httpRequestSaga";

function* rootSaga() {
  /*The saga is waiting for a action called LOAD_DASHBOARD to be activated */
  yield all([watchHttpAction()]);
}

export default rootSaga;
